<template>
  <DBox
    :id="'dbx-invoice-contact'"
    :addButton="false"
    :addLink="showLink"
    :addLinkLabel="'Add a Contact'"
    @add_click="onAddInvoiceContact"
  >
    <div
      v-if="invoiceContact && invoiceContact.contact_id"
      style="height:32px;min-height:32px"
      class="fc2 fc2-row ut-flex company-name-content"
    >
      <label
        style="min-width: 125px; margin-top: 0px"
        class="fc2-label txtov"
        >{{
          invoiceContact.company_name && invoiceContact.company_name != ""
            ? $dft.snakeCaseToWords("company_name")
            : $dft.snakeCaseToWords("name")
        }}</label
      >

      <div class="ut-flex ut-link ut-text-accent5">
        <span
          @click="onCompanyClick"
          v-if="
            invoiceContact.company_name && invoiceContact.company_name != ''
          "
          class="company-name"
          >{{ invoiceContact.company_name }}</span
        >
        <span  @click="onCompanyClick" v-else class="company-name"
          >{{ invoiceContact.first_name }} {{ invoiceContact.last_name }}</span
        >
        <div class="dt-icon-container" @click="onAddInvoiceContact()">
          <img
            src="static/icons/lupe.svg"
            class="dt-icon v5 s2"
            alt="name"
            title="Company Name"
          />
        </div>
      </div>
    </div>

    <div 
      :style="{
        height:`${heightCalc}px`,
      }" 
      class="ut-fc"
      v-if="invoiceContact && invoiceContact.contact_id"
    >
      <TextField2
        v-if="invoiceContact.address1"
        style="flex: 1"
        :disabled="'disabled'"
        :id="'address1'"
        :placeholder="$t('address1')"
        :label="$t('address')"
        :value="`${invoiceContact.address1}`"
      />
      <TextField2
        class="mt-top"
        style="flex: 1"
        :disabled="'disabled'"
        :id="'postalcode'"
        :placeholder="$t('city')"
        :label="$t('postalcode')"
        v-if="invoiceContact.postalcode || invoiceContact.city"
        :value="`${invoiceContact.postalcode||''} ${invoiceContact.city||''}`"
      />
      <TextField2
        class="mt-top"
        style="flex: 1"
        :disabled="true"
        :id="'country'"
        :placeholder="$t('country')"
        :label="$t('country')"
        v-if="invoiceContact.country"
        :value="invoiceContact.country"
      />
      <TextField2
        class="mt-top"
        style="flex: 1"
        :disabled="'disabled'"
        :id="'phone1'"
        :placeholder="$t('phone')"
        :label="$t('phone')"
        v-if="invoiceContact.phone1"
        :value="invoiceContact.phone1"
      />
      <TextField2
        class="mt-top"
        style="flex: 1"
        :disabled="'disabled'"
        :id="'mobile'"
        v-if="invoiceContact.phone2"
        :placeholder="$t('mobile')"
        :label="$t('mobile')"
        :value="invoiceContact.phone2"
      />
      <TextField2
        class="mt-top"
        style="flex: 1"
        :disabled="'disabled'"
        :id="'fax1'"
        v-if="invoiceContact.fax1"
        :placeholder="$t('fax')"
        :label="$t('fax')"
        :value="invoiceContact.fax1"
      />
      <TextField2
        class="mt-top"
        style="flex: 1"
        :disabled="'disabled'"
        :id="'email'"
        :placeholder="$t('email')"
        :label="$t('email')"
        :icon="'email-blue'"
        v-if="invoiceContact.email1"
        :value="invoiceContact.email1"
        @iconClick="onEmailClick"
      />
    </div>
  </DBox>
</template>

<script>
import DBox from "@dtplugins/dbox/dbox";
import { onDetailsRowClicked } from "../../utility/route";
import { contactListLDTRoutes } from "../../modules/contacts/router/routes";
import { sendMailHref } from "../../utility";

export default {
  props: {
    invoiceContact: {
      type: Object,
    },
    contactConfig: {
      type: Object,
      default: () => {
        return {
          external_id: "",
          external_table: "",
          key: "",
          external_name: "",
          config_type: "",
        };
      },
    },
  },
  components: {
    DBox,
  },
  computed:{
    showLink:function(){ 
      return this.invoiceContact?.contact_id ? false : true
    },
    heightCalc:function(){
      const { address1 , postalcode ,city ,country ,phone1,phone2,fax1 ,email1} =this.invoiceContact;

      const obj= { address1 , postalcode ,city ,country ,phone1,phone2,fax1 ,email1}

      const arrr = Object.entries(obj).map(x=>{
        return {
          key:x[0],
          value:x[1]||''
        }
      });

      let h = arrr.reduce((accum,cur)=>{
        if(cur['value']!=''){
          accum+=1
        }
        return accum;
      },0)

      if(arrr[1]['value']!='' && arrr[2]['value']!=''){
        h-=1
       // console.log(h,arrr)
      }

      const offSet = parseFloat((h*10)/32);


      // console.log({offSet,h,arrr})
      return (h- Math.floor(offSet))*32;
    },
    topMargin:function(){
      return this.showLink?0:this.invoiceContact.address1?5:10
    }
  },
  data: function () {
    return {};
  },
  methods: {
    onAddInvoiceContact: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: "add_contact_relation",
          external_id: this.contactConfig.external_id,
          external_table: this.contactConfig.external_table,
          external_name: this.contactConfig.external_name,
          key: this.contactConfig.key,
          config_type: this.contactConfig.config_type,
        },
      });
    },

    onCompanyClick: function () {
      onDetailsRowClicked(
        this.$router,
        this.invoiceContact,
        contactListLDTRoutes
      );
    },

    onEmailClick:function(){
      sendMailHref({subject:'',body:'',mails:[this.invoiceContact.email1]})
    }
  },
};
</script>
<style lang="scss">
.dbx-invoice-contact {
  .company-name-text {
    padding-left: 30px !important;
  }
  .mt-top {
   // margin-top: -10px;
    //max-height: 22px;
  }

  .fc2 {
    max-height: 22px;
    min-height: 22px;
    --bb: none !important;
    --fc2-bc: #fff !important;
    --fc2-bdc: #fff !important;
    textarea.fc-control {
      max-height: 22px;
      min-height: 22px;
      &:hover {
        --fc2-bc: #fff !important;
        --fc2-bdc: #fff !important;
      }
    }
    input.fc-control {
       max-height: 22px;
      min-height: 22px;
      &:hover,
      &:hover:not(.company-name) {
        --fc2-bc: #fff !important;
        --fc2-bdc: #fff !important;
      }
    }
  }
  .company-name-content {
    border-bottom: 1px solid var(--sprt-85) !important;
    .company-name {
      width: 100%;
    }
  }

  .fc2.disabled {
    --fc2-bc: #fff;
  }

  .fc2-row {
    --bb: 1px solid var(--sprt-85);

    height: 30px;
    border-bottom: var(--bb);
    > .ut-flex {
      flex: 1;
      padding: var(--fc2-tf-padding);
      margin: var(--fc2-tf-margin);
      min-width: 0;
      outline: none;
    }

    .no-label {
      margin-top: 12px;
    }
  }
}
</style>